export default "__VITE_ASSET__$h0wgPMF__"